import IRimg1 from "../assets/img/ir1.jpg";
import IRimg2 from "../assets/img/ir2.jpg";
import IRimg3 from "../assets/img/ir3.jpg";

import NZimg1 from "../assets/img/nz1.jpg";
import NZimg2 from "../assets/img/nz2.jpg";
import NZimg3 from "../assets/img/nz3.jpg";

import BPimg1 from "../assets/img/bp1.jpg";
import BPimg2 from "../assets/img/bp2.jpg";
import BPimg3 from "../assets/img/bp3.jpg";

import WMimg1 from "../assets/img/wm1.jpg";
import WMimg2 from "../assets/img/wm2.jpg";
import WMimg3 from "../assets/img/wm3.jpg";

import PRimg1 from "../assets/img/pr1.jpg";
import PRimg2 from "../assets/img/pr2.jpg";
import PRimg3 from "../assets/img/pr3.jpg";

import KKimg1 from "../assets/img/kk1.jpg";
import KKimg2 from "../assets/img/kk2.jpg";
import KKimg3 from "../assets/img/kk3.jpg";

import MWimg1 from "../assets/img/mw1.jpg";
import MWimg2 from "../assets/img/mw2.jpg";
import MWimg3 from "../assets/img/mw3.jpg";

import KKozimg1 from "../assets/img/kkoz1.jpeg";
import KKozimg2 from "../assets/img/kkoz2.jpeg";
import KKozimg3 from "../assets/img/kkoz3.jpeg";

import ETimg1 from "../assets/img/et1.jpg";
import ETimg2 from "../assets/img/et2.jpg";
import ETimg3 from "../assets/img/et3.jpg";

import AMimg1 from "../assets/img/am1.jpg";
import AMimg2 from "../assets/img/am2.jpeg";
import AMimg3 from "../assets/img/am3.jpeg";

import MPimg1 from "../assets/img/mp1.jpeg";
import MPimg2 from "../assets/img/mp2.jpeg";
import MPimg3 from "../assets/img/mp3.jpeg";

import PKimg1 from "../assets/img/pk1.jpeg";
import PKimg2 from "../assets/img/pk2.jpeg";
import PKimg3 from "../assets/img/pk3.jpeg";

function getFormattedPerson(person) {
  return (
    <div id={person.id} key={person.name} className="team__section">
      <div className="team__name">{person.name}</div>
      <div className={person.text ? "team__imgs" : "team__imgs-no-text"}>
        <div className={person.text ? "team__img" : "team__img-no-text"}>
          <img src={person.img1} alt="" />
        </div>
        <div className={person.text ? "team__img" : "team__img-no-text"}>
          <img src={person.img2} alt="" />
        </div>
        <div className={person.text ? "team__img" : "team__img-no-text"}>
          <img src={person.img3} alt="" />
        </div>
      </div>
      <div className="team__text">
        <p>{person.text}</p>
      </div>
    </div>
  );
}

const TeamPerson = () => {
  const teachingTeamPersons = [
    {
      name: "Ignacy Rejmak",
      id: "Ignacy-Rejmak",
      img1: IRimg1,
      img2: IRimg2,
      img3: IRimg3,
      text: [
        "- nauczyciel fizyki w Szkole podstawowej nr 1 w Bolszewie, Podstawowej Ekologicznej Szkole Społecznej w Rumi.",
        <br />,
        <br />,
        "Pracuje z uczniami szczególnie uzdolnionymi w kierunku przedmiotów ścisłych, przygotowując ich do konkursów i olimpiad zarówno fizycznych, matematycznych i informatycznych. Przez ten czas wychował ponad 30 laureatów i finalistów, głównie konkursów fizycznych. Od 15 lat współorganizuje obozy naukowe.",
        <br />,
        <br />,
        "Przez swoje niekonwencjonalne metody nauczania, niezwykłą osobowość a także relacje z młodzieżą, często porównywany do bohatera książki „Stowarzyszenie Umarłych Poetów”. Twierdzi, że ma więcej szczęścia niż rozumu, gdyż w szkołach w których pracuje zawsze trafia na nauczycieli, od których ciągle może się bardzo wiele nauczyć.",
        <br />,
        <br />,
        "Ignacy Rejmak jest bohaterem niezwykłego filmu dokumentalnego, który swoją premierę miał we wrześniu 2020. “Nieletni inżynierowie” to historia przemiany, odkrywania pasji i zdobywania wiedzy. To opowieść o miłości do nauki i mocy relacji, tak bardzo nam dzisiaj potrzebnej.",
        <br />,
        <br />,
        "Film pojawił się na międzynarodowych festiwalach otrzymując wiele cennych nagród takich jak: Festiwal Cineminha B. w Brazylii, International CHINH INDIA KIDS FILM FESTIVAL w Indiach, Delco Film Festival w USA, Polish Film Festival Los Angeles, Festiwalu Filmowym Zlin w Czechach, Satisfied Eye International Film Festival w Wielkiej Brytanii gdzie stał się Najlepszym Filmem Dokumentalnym, a Ignacy Rejmak otrzymał na tym festiwalu Nagrodę Jury Satisfied Eye International Film Festival.",
        <br />,
        "Więcej o filmie:",
        <br />,
        <a href="//underage.pro/inzynierowie ">
          https://underage.pro/inzynierowie
        </a>,
        <br />,
        <br />,
        "Ponadto Ignacy Rejmak wraz z Przemysławem Rojewskim uczestniczy w unikalnym projekcie edukacyjnomedialnym dla uczniów i nauczycieli klas szkół podstawowych oraz średnich realizowanym w Powiatowym Zespole Szkół nr 2 im. Bohaterskiej Załogi ORP “Orzeł” w Wejherowie „Fizyka dla nieletnich”.",
        <br />,
        <br />,
        "Projekt zakłada tworzenie 12-minutowych odcinków dla uczniów, które są dostępne na Facebooku oraz kanale YouTube. Ich celem jest wyjaśnianie zjawisk fizycznych w prosty, przystępny, a zarazem ciekawy sposób, a w efekcie zachęcenie młodych ludzi do zawodów i kierunków technicznych",
        <br />,
        "Więcej o projekcie:",
        <br />,
        <a href="//underage.pro/fizyka ">http://underage.pro/fizyka</a>,
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z fizyki.",
      ],
    },
    {
      name: "Natalia Zarańska",
      id: "Natalia-Zaranska",
      img1: NZimg1,
      img2: NZimg2,
      img3: NZimg3,
      text: [
        "- coach, trener i mówca Maxwell Leadership Certified Team Poland, trener psychologii pozytywnej, facylitator job craftingu, doradca zawodowy. Zakochana w zmianie. Z pierwszego wykształcenia jest pedagogiem i przez 22 lata prowadziła młodych ludzi w okresie dojrzewania, wspierała także rodziców, prowadząc szkolenia i warsztaty.",
        <br />,
        <br />,
        "Właścicielka Akademii Rozwoju Prosperity oraz Soward Smart Kids Academy będącej przestrzenią rozwoju młodych ludzi w zakresie kompetencji społecznych, matematyki mentalnej, edukacji medialnej i krytycznego korzystania z mediów oraz międzynarodowej metody Brainy Sensory Enhancement.",
        <br />,
        <br />,
        "Od wielu lat wspiera nauczycieli prowadząc szkoleniowe Rady Pedagogiczne, współpracując w tym zakresie m.in. z Pomorskim Ośrodkiem Doskonalenia Nauczycieli w Słupsku. Prezes Stowarzyszenia FPUNKT. Finalistka konkursu im. Ireny Sendlerowej „Za naprawianie świata”. Absolwentka programu wymiany rządu USA International Visitor Leadership. Za swoje działania otrzymała Medal Komisji Edukacji Narodowej.",
        <br />,
        <br />,
        "Jej pasją są musicale, które tworzy wspólnie z młodzieżą. Jej spektakle stanęły na Stadionie Narodowym (spektakl „Szukając siebie”) a także na dużej scenie Teatru Muzycznego w Gdyni (musical „Szepty serc”). Przez wiele lat realizowała profilaktykę rówieśniczą pokazując młodym ludziom możliwości własnego rozwoju, ucząc, że ciekawość to nie pierwszy stopień do piekła, a możliwość dokonywania niemożliwego.",
        <br />,
        <br />,
        <a href="//nataliazaranska.pl">www.nataliazaranska.pl</a>,
        <br />,
        <a href="//https://smartkids.soward.eu">https://smartkids.soward.eu</a>,
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z kompetencji społecznych.",
      ],
    },
    {
      name: "Bogusław Pranszke",
      id: "Boguslaw-Pranszke",
      img1: BPimg1,
      img2: BPimg2,
      img3: BPimg3,
      text: [
        "- dr hab., prof. nadz. Uniwersytetu Morskiego w Gdyni. Pracuje na Wydziale Mechanicznym UMG, w Katedrze Fizyki. Fizyk, specjalność - fizyka doświadczalna. Pracował z uczniami szczególnie uzdolnionymi w kierunku przedmiotów ścisłych, przygotowując ich do olimpiad fizycznych. Zainteresowania: nauczanie oraz  popularyzacja fizyki i astronomii, filmy i książki sf, gry planszowe oraz, od ponad 15 lat, AoC (gra komputerowa Age of Empires II: The Conquerors).",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z fizyki.",
      ],
    },
    {
      name: "Wojciech Malicki",
      id: "Wojciech-Malicki",
      img1: WMimg1,
      img2: WMimg2,
      img3: WMimg3,
      text: [
        "- swój pierwszy program komputerowy napisał w wieku 12 lat na komputerze Commodore 64. Od tego czasu uczy się nowych języków programowania i nieustannie poszerza swoją wiedzę i umiejętności, przechodząc od Basica przez Pascala do C++ i Pythona po drodze zahaczając o JavaScript i VBA. Od 2010 roku pracuje jako nauczyciel, nie tylko w szkole, ale także w projektach związanych z zajęiami dla młodzieży uzdolnionej w Słupsku, Lęborku i Kartuzach. Od 2012 roku uczestniczy w obozach naukowych w czasie wakacji. Przygotowywał również uczniów do olimpiad informatycznych, w tym do olimpiady z programowania zespołowego. Aby podnieść swoje umiejętności uczestniczy w warsztatach informatycznych. Ukończył studia podyplomowe z zakresu testowania oprogramowania, programowania aplikacji internetowych oraz cyberbezpieczeństwa. Najbardziej ceni u siebie zapał do uczenia się nowych rzeczy i ciekawość. Od września 2025 roku jest magistrem filozofii.",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z programowania.",
      ],
    },
    {
      name: "Przemysław Rojewski",
      id: "Przemyslaw-Rojewski",
      img1: PRimg1,
      img2: PRimg2,
      img3: PRimg3,
      text: [
        "- nauczyciel fizyki w Powiatowym Zespole Szkół nr 2 w Wejherowie. W zawodzie od ponad 20 lat. Przez 12 lat pracował z uczniami szczególnie uzdolnionymi w ramach Projektu „Zdolni z Pomorza” przygotowując ich do konkursów i olimpiad szczególnie w części doświadczalnej. Przez ten czas wychował wielu laureatów i finalistów. Co najważniejsze jest doświadczonym egzaminatorem i od wielu lat uczestniczy w pracach komisji egzaminacyjnej egzaminu maturalnego z fizyki. Również przygotowuje z powodzeniem uczniów do tego egzaminu. ",
        <br />,
        <br />,
        "Od kilku lat tworzy pracownię fizyczną z prawdziwego zdarzenia wyposażoną w najnowocześniejszy dostępny sprzęt pomiarowy. W czasie wolnym nie może obyć się bez treningów biegowych jest zwycięzcą wielu biegów długodystansowych i maratonów.",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z fizyki.",
      ],
    },
    {
      name: "Kamil Kostrzewa",
      id: "Kamil-Kostrzewa",
      img1: KKimg1,
      img2: KKimg2,
      img3: KKimg3,
      text: [
        "- doktor nauk fizycznych, nauczyciel fizyki i matematyki z ponad dziesięcioletnim stażem, najpierw w gdańskich podstawówkach, gimnazjach i liceach, obecnie w lęborskim liceum. Aktywny popularyzator nauki, prowadzi zajęcia między innymi w MateManiakach, czy Zdolnych z Pomorza. Od ponad pięciu lat autor i twórca Wykładów Otwartych z Fizyki. Prywatnie miłośnik literatury i filmów fantasy, gier strategicznych oraz papierowych rpg-ów, siatkówki i eleganckich ubrań. Nauczycielem fizyki chciał być od zawsze (dokładniej od pierwszej lekcji fizyki w gimnazjum), choć z krótką przerwą na marzenia o byciu papieżem.",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z matematyki.",
      ],
    },
    {
      name: "Mateusz Woźniak",
      id: "Mateusz-Woźniak",
      img1: MWimg1,
      img2: MWimg2,
      img3: MWimg3,
      text: [
        "- nauczyciel biologii i  chemii w X Liceum Ogólnokształcącym w Gdyni. Uczy i wychowuje od 20 roku życia.  Pracował na prawie wszystkich szczeblach edukacji – od szkoły podstawowej, po gimnazjum i szkoły ponadpodstawowe. Przez lata swojej pracy przygotowywał uczniów do konkursów, olimpiad w szczególności ekologicznej, biologicznej i chemicznej. Jest doświadczonym egzaminatorem z biologii i chemii i przez wiele lat aktywnie uczestniczył w pracach komisji egzaminacyjnej egzaminu maturalnego. Korepetytor pracujący przez lata w Indeks Edukacja i Ratajczuk Edukacja. W czasie zajęć przygotowywał uczniów do egzaminu maturalnego z biologii i z chemii. Od lat współpracuje z wydziałem Biologii  UG i jest opiekunem Samorządu XLO.",
        <br />,
        <br />,
        "Prywatnie uwielbia gry komputerowe (przygodówki, rpg i strategiczne),  jest także miłośnikiem gier planszowych. Nie pogardzi również kryminałem czy książką fantasy. ",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z chemii i biologii.",
      ],
    },
    {
      name: "Kamil Kozakiewicz",
      id: "Kamil-Kozakiewicz",
      img1: KKozimg1,
      img2: KKozimg2,
      img3: KKozimg3,
      text: [
        "- nauczyciel matematyki w X Liceum Ogólnokształcącym w Gdyni.",
        <br />,
        <br />,
        "Uwielbia pracować z grupami rozszerzonymi i patrzeć, jak jego podopieczni przesuwają granice swojej wiedzy. Nieustannie się uczy, by uczyć coraz lepiej, bo sukces ucznia, to dla niego najlepsze paliwo do pracy. Wierzy, że rola nauczyciela to nie tylko przekazywanie faktów, ale przede wszystkim wspieranie uczniów w procesie odkrywania ich potencjału. Przygotowuje uczniów do konkursów matematycznych, w których zdobywają tytuły finalistów i laureatów.",
        <br />,
        <br />,
        "Na co dzień miłośnik podróży (tych małych i tych dużych) oraz wielbiciel gotowania.",
      ],
    },
    {
      name: "Ewa Tabor",
      id: "Ewa-Tabor",
      img1: ETimg1,
      img2: ETimg2,
      img3: ETimg3,
      text: [
        "- psycholog w trakcie studiów podyplomowych w dziedzinie psychoonkologii klinicznej. Posiada przygotowanie pedagogiczne do zawodu nauczyciela psychologa. Planuje rozpocząć 4-letnie całościowe szkolenie psychoterapeutyczne w nurcie integracyjno-systemowym oraz studia podyplomowe w zakresie suicydologii.",
        <br />,
        <br />,
        "Doświadczenie zawodowe zdobywała pracując jako psycholog w szkole podstawowej, a także podczas praktyk i wolontariatu w hospicjum. Brała udział w projektach edukacyjnych i profilaktycznych, prowadząc zajęcia dla dzieci i młodzieży.",
        <br />,
        <br />,
        "W ramach prywatnej praktyki psychologicznej udziela konsultacji dzieciom, młodzieży i dorosłym.",
        <br />,
        <br />,
        "Trenerka metody Soward Skills w Soward Smart Kids Lębork. Na kursie uczy dzieci kluczowych kompetencji życiowych i społecznych. Program Soward Skills poprawia umiejętności dziecka w zakresie kreatywności, uważności, budowania relacji i panowania nad emocjami.",
        <br />,
        <br />,
        "Praktyk w zakresie metod Kid’s Skills - Dam Radę oraz I’m Proud of You - Jestem z Ciebie Dumny. Metoda Kids’ Skills wspiera dzieci w przezwyciężaniu trudności poprzez rozwijanie konkretnych umiejętności, natomiast program I’m Proud of You koncentruje się na wzmacnianiu relacji z dzieckiem poprzez docenianie, konstruktywne chwalenie oraz budowanie współpracy opartej na szacunku i zaufaniu.",
        <br />,
        <br />,
        "W swojej pracy szczególną wagę przywiązuje do budowania relacji opartej na zaufaniu, poczuciu bezpieczeństwa i akceptacji.",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z kompetencji społecznych.",
        <br />,
        <br />,
        <a href="https://przystanduszyewatabor.pl/">
          https://przystanduszyewatabor.pl/
        </a>,
      ],
    },
    {
      name: "Aleksandra Mrzygłocka",
      id: "Aleksandra-Mrzygłocka",
      img1: AMimg1,
      img2: AMimg2,
      img3: AMimg3,
      text: [
        "- absolwentka studiów I stopnia na kierunku bezpieczeństwo wewnętrzne, ukończyła kursy: trenera uważności, trenera mindfulnessu, trenera zarządzania emocjami, trenera umiejętności społecznych I i II stopnia, a także kursy w zakresie terapii behawioralno-poznawcze oraz terapii zajęciowej.",
        <br />,
        <br />,
        "Absolwentka studiów podyplomowych na kierunku pedagogika specjalna oraz przygotowanie psychologiczno-pedagogiczne i dydaktyczne.",
        <br />,
        <br />,
        "Trenerka międzynarodowej metody Soward Skills oraz Brainy Sensory Enhancement w Soward Smart Kids Lębork. Zaangażowana w rozwój kompetencji emocjonalnych u dzieci uzdolnionych podczas obozów naukowych. Nauczycielka współorganizująca kształcenie w Społecznej Językowej Szkole Podstawowej LTO w Lęborku.",
        <br />,
        <br />,
        "Od 2024r. aktywnie realizuje projekt “Sukcesu nie mierzy się oceną” prowadząc zajęcia w klasach I - V metodą Brainy Abacus. Jest zaangażowana w działania Stowarzyszenia FPUNKT organizując konferencje edukacyjne, a także prowadząc warsztaty dla dzieci, młodzieży i dorosłych  w projektach realizowanych przez Stowarzyszenie takich jak m.in. “LIFE SKILLS – fundament kompetencji społecznych XXI wieku”, “Razem w harmonii – emocje i relacje w szkolnej społeczności”,  „Bezpieczna Gmina – Gotowi na wyzwania, bo odporny umysł to silna społeczność”, międzynarodowy projekt ERASMUS  „Level Up Rural: 4 Work Ready, 4 Future Steady”.",
        <br />,
        <br />,
        "W Osadzie Wiedzy prowadzi zajęcia z kompetencji społecznych.",
      ],
    },
  ];

  const supervisingTeamPersons = [
    {
      name: "Magdalena Panas",
      id: "Magdalena-Panas",
      img1: MPimg1,
      img2: MPimg2,
      img3: MPimg3,
      text: [
        "- studentka II roku filologii angielskiej na Uniwersytecie Gdańskim. Zanim odkryła w sobie pasję do języków obcych, uczyła się w liceum na profilu matematyczno-fizycznym. Właśnie wtedy rozpoczęła swoją przygodę z Osadą Wiedzy, po raz pierwszy przyjeżdżając na obóz jako uczestniczka. Cztery edycje jej nie wystarczyły i po zakończeniu szkoły średniej powróciła na Osadę Wiedzy jako część kadry.",
        <br />,
        <br />,
        "Jej życiem jest muzyka. Uwielbia taniec i śpiew, czym podbija każde karaoke. Swoją energię od 10 lat rozładowuje na boisku, grając w siatkówkę. W wolnych chwilach angażuje się w tworzenie życia studenckiego dla osób uczących się na UG w ramach wymian międzynarodowych. Sama spędziła ostatni semestr na takiej wymianie w Chorwacji, szlifując swój angielski i poznając nowy język i kulturę.",
        <br />,
        <br />,
        "W Osadzie Wiedzy pełni rolę wychowawcy, organizując uczestnikom czas wolny. Jako specjalistka w rozwiązywaniu krzyżówek panoramicznych, wymyśla obozowiczom wszelakie zadania i łamigłówki, a swoje siatkarskie doświadczenie wykorzystuje do kreowania sportowych aktywności między zajęciami.",
      ],
    },
    {
      name: "Paweł Kotłowski",
      id: "Paweł-Kotłowski",
      img1: PKimg1,
      img2: PKimg2,
      img3: PKimg3,
      text: [
        "- student pierwszego roku elektrotechniki na Politechnice Gdańskiej. Uczęszczał do II Liceum Ogólnokształcącego w Gdańsku do klasy o profilu matematyczno fizycznym z rozszerzonym językiem angielskim. Od 2020 roku uczestnik obozów “Osada wiedzy” na których, pod skrzydłami kadry rozwijał swoje zainteresowanie przedmiotami ścisłymi, a także poznawał wielu wspaniałych ludzi. W 2025 roku dołączył do kadry obozowej.",
        <br />,
        <br />,
        "Jego zainteresowania to między innymi sport, muzyka, motoryzacja oraz projekty takie jak “Odyseja Umysłu”, które wymagają kreatywności oraz szybkiego rozwiązywania wszelakich problemów.",
        <br />,
        <br />,
        "Na “Osadzie Wiedzy” pełni rolę wychowawcy. Spędza z uczestnikami każdą wolną chwilę nie przeznaczoną na zajęcia. Prowadzi zajęcia sportowe, które dają wytchnienie po intensywnej pracy umysłowej.",
      ],
    },
  ];
  return (
    <>
      <h2 className="header team__header">KADRA DYDAKTYCZNA</h2>
      {teachingTeamPersons.map(getFormattedPerson)}
      <h2 className="header team__header">KADRA WYCHOWAWCZA</h2>
      {supervisingTeamPersons.map(getFormattedPerson)}
    </>
  );
};

export default TeamPerson;
